import { createXmlHttpRequest } from './xml-http-request';
import { debug } from './debug';

export const MSG_REQUEST_ABORTED = 'Request aborted';

const onLoad = ({ resolve, reject, retry }) => ({ target: { status, response } }) => {
  switch (true) {
    case status >= 500:
      debug.info('[XMLHttpRequest] failed', { status, response });

      if (retry) {
        debug.info('[XMLHttpRequest] retrying');
        return retry();
      } else {
        debug.info('[XMLHttpRequest] retries exceeded, failing');
        return reject({ status, response });
      }
    case status >= 400:
      return reject({ status, response });
    default:
      try {
        resolve(JSON.parse(response));
      } catch (error) {
        resolve(response);
      }
  }
};

const onAbort = reject => () => {
  reject(MSG_REQUEST_ABORTED);
};

const sendRequest = ({ apiBaseUrl, instance, locale, method, body, path, retries = 0, retryDelay = 500 }) => {
  const request = createXmlHttpRequest({ method, url: `${apiBaseUrl}${path}`, headers: { instance, locale } });

  const promise = new Promise((resolve, reject) => {
    const retry =
      retries > 0
        ? () =>
            sendRequest({ apiBaseUrl, instance, locale, method, body, path, retries: retries - 1, retryDelay }).then(
              resolve,
              reject,
            )
        : undefined;

    request.addEventListener('load', onLoad({ resolve, reject, retry }));
    request.addEventListener('error', reject);
    request.addEventListener('abort', onAbort(reject));
  });

  promise.abort = () => request.abort();

  request.send(body);
  return promise;
};

const createCancellableRequest = ({ apiBaseUrl = '', instance = '', locale = 'en' }) => ({
  method,
  body,
  path,
  retries = 0,
  retryDelay = 500,
}) => sendRequest({ apiBaseUrl, instance, locale, method, body, path, retries, retryDelay });

export default createCancellableRequest;
